// Studio contact details and public claims.
//
// One place, so a number can never disagree with itself across components
// again. Anything you cannot fill in truthfully should stay `null` — the UI
// omits null fields rather than rendering a placeholder.

export const STUDIO = {
  name: 'Handmade bee',
  tagline: 'Bespoke Handcrafted Atelier',

  // Digits only, country code first — this is what wa.me and tel: both use.
  phone: '919747901029',
  // How it should read on screen. Derived below so the two cannot drift.
  get phoneDisplay() {
    const d = this.phone;
    return `+${d.slice(0, 2)} ${d.slice(2, 7)} ${d.slice(7)}`;
  },

  // Where the studio works from.
  //
  // Structured rather than a single string, because Google's LocalBusiness
  // markup wants the parts separately — and a `PostalAddress` with a real
  // `addressLocality` is what makes the difference between ranking for
  // "Aari embroidery Thrissur" and ranking for nothing at all.
  //
  // No street line: this is a service-area studio, not a shop with a counter.
  // Omitting `streetAddress` is correct here, and better than inventing one.
  place: {
    locality: 'Manathala',
    city: 'Thrissur',
    region: 'Kerala',
    country: 'IN',
    countryName: 'India',
    // Towns the studio takes work from. Used for `areaServed`; keep this
    // honest — it is a claim about where you will actually deliver.
    areaServed: ['Thrissur', 'Guruvayur', 'Chavakkad', 'Kunnamkulam', 'Kerala'],
    get display() {
      return `${this.locality}, ${this.city}, ${this.region}`;
    },
  },

  email: null,
  hours: null,

  // Tracking parameters stripped. `?igsi=...` is a share token tied to one
  // session; it does not belong in a canonical `sameAs` URL, and a search
  // engine treats the cleaned form as the identity of the account.
  instagram: 'https://www.instagram.com/handmade__bee',

  // Year the studio started taking commissions — not the year the Instagram
  // account was created, which is 2022. Used instead of invented volume and
  // rating figures.
  since: 2010,
};

export default STUDIO;
